import { render, staticRenderFns } from "./Justified.vue?vue&type=template&id=b995df92"
import script from "./Justified.vue?vue&type=script&lang=js"
export * from "./Justified.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports